import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { activeCallsSelector } from '../selectors/dashboardSelector';
import { getActiveCallsRequest } from '../actions/dashboardActions';
import ActiveCalls from '../components/ActiveCalls/ActiveCalls';

const mapStateToProps = createStructuredSelector({ activeCalls: activeCallsSelector });
const mapDispatchToProps = { getActiveCallsRequest };

export default connect(mapStateToProps, mapDispatchToProps)(ActiveCalls);
